import { createApi } from '@reduxjs/toolkit/query/react'

import { getReservaCentralizadaDetalleQueryOData } from '../constants/queriesStringOData'
import { getQueryReservaDetallePaxOData } from '../constants/queryReservaCentralizadaDetallePax'
import {
  ReservaCentralizadaDetalle,
  ReservaCentralizadaDetalleModal,
} from '../interfaces/ReservaCentralizadaDetalleModal'

import { ReservaDetailPaxResponse } from '../interfaces/ReservaCentralizadaDetallePax.response'

import { baseQuery } from '@/core/api/baseQuery'
import { GenericResponseOData } from '@/core/api/interfaces/GenericResponseOData'

export const reservaCentralizadaDetalleApi = createApi({
  reducerPath: 'reservaCentralizadaDetalleApi',
  baseQuery,
  endpoints: (builder) => ({
    getReservaDetalleModal: builder.query<GenericResponseOData<ReservaCentralizadaDetalleModal[]>, { id: number }>({
      query: (params: { id: number }) => ({
        url: `/ReservasCentralizadas?${getReservaCentralizadaDetalleQueryOData.select}${getReservaCentralizadaDetalleQueryOData.filter}${params.id}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    updateReservaDetalle: builder.mutation<void, ReservaCentralizadaDetalle>({
      query: (body) => ({
        url: `/ReservaCentralizadaDetalles(${body.ReservaCentralizadaDetalleId})`,
        method: 'PUT',
        body,
      }),
    }),
    getReservaDetallePax: builder.query<GenericResponseOData<ReservaDetailPaxResponse[]>, { detailIds: number[] }>({
      query: ({ detailIds }) => ({
        url: `/ReservaCentralizadaDetalles?${getQueryReservaDetallePaxOData(detailIds)}`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useLazyGetReservaDetalleModalQuery, useUpdateReservaDetalleMutation, useLazyGetReservaDetallePaxQuery } =
  reservaCentralizadaDetalleApi
